var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShoppingBagNewIcon = function SvgShoppingBagNewIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#404A5C",
    d: "M5.369 18.667q-.843 0-1.44-.6-.596-.6-.596-1.442V7q0-.842.6-1.442t1.442-.6h1.354v-.333q0-1.334.923-2.312.923-.98 2.348-.98 1.362 0 2.316.896.954.895.954 2.23v.5h1.355q.842 0 1.442.6.6.599.6 1.441v9.625q0 .842-.6 1.442t-1.443.6zm.006-2.042h9.25V7H13.27v.98q0 .422-.298.721a.98.98 0 0 1-.719.299q-.42 0-.723-.299a.98.98 0 0 1-.302-.722V7H8.77v.98q0 .422-.298.721A.98.98 0 0 1 7.754 9q-.42 0-.723-.299a.98.98 0 0 1-.302-.722V7H5.375zM8.77 4.958h2.458v-.5a.97.97 0 0 0-.37-.778 1.32 1.32 0 0 0-.864-.305q-.495 0-.86.305a.97.97 0 0 0-.364.778z"
  })));
};
export default SvgShoppingBagNewIcon;